var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhyinline = function SvgWhyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M15.499 8.003a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m9.181 6.08.116.236.26.038 2.464.358h.001l.08.012a.1.1 0 0 1 .044.02l.323-.382-.323.383a.09.09 0 0 1 .005.131l-1.84 1.793-.189.183.044.26.435 2.533a.09.09 0 0 1-.036.087l.294.404-.294-.404a.09.09 0 0 1-.094.007l-2.274-1.196-.233-.122-.233.122-2.275 1.197a.09.09 0 0 1-.13-.094l.435-2.533.044-.26-.188-.183-1.84-1.794a.09.09 0 0 1 .05-.152l2.544-.37.26-.037.116-.236 1.125-2.283a.113.113 0 0 1 .184 0z"
  })));
};
export default SvgWhyinline;